import React, { useState } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import AnimatedSection from "../common/AnimatedSection";
import SectionHeading from "../common/SectionHeading";

const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0"; const PURPLE = "#845EF7";

const QUOTE_COLORS = [YELLOW, TEAL, CORAL];

const TestimonialsSection = ({ testimonials }) => {
  const [active, setActive] = useState(0);

  return (
    <AnimatedSection sx={{ backgroundColor: "#FFF8F0", py: { xs: 9, md: 12 } }}>
      <Container maxWidth="xl">
        <SectionHeading
          eyebrow="Parent Stories"
          title="What Parents Say About St Lord's ❤️"
          description="Hear from parents about their experiences, their children's growth and the learning journey at St Lord's"
          align="center"
          eyebrowColor={CORAL}
          eyebrowBg="#FFE8E8"
        />

        <Grid container spacing={3} sx={{ mb: 4 }}>
          {testimonials.map((t, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Box
                onClick={() => setActive(i)}
                sx={{
                  p: 3.5, height: "100%", cursor: "pointer",
                  borderRadius: "18px",
                  border: `2.5px solid ${NAVY}`,
                  backgroundColor: active === i ? QUOTE_COLORS[i] : "#fff",
                  boxShadow: active === i ? `6px 6px 0 ${NAVY}` : `4px 4px 0 ${NAVY}`,
                  transform: active === i ? "translate(-2px,-2px)" : "none",
                  transition: "all 0.2s ease",
                  "&:hover": { transform: "translate(-2px,-2px)", boxShadow: `6px 6px 0 ${NAVY}` },
                }}
              >
                {/* Quote mark */}
                <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "4rem", color: active === i ? "rgba(27,31,59,0.2)" : `${QUOTE_COLORS[i]}55`, lineHeight: 0.8, mb: 1 }}>
                  "
                </Typography>
                <Typography sx={{ fontWeight: 700, color: NAVY, lineHeight: 1.8, fontSize: "0.95rem", mb: 2.5, fontStyle: "italic" }}>
                  "{t.quote}"
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Box sx={{ width: 42, height: 42, borderRadius: "50%", border: `2px solid ${NAVY}`, backgroundColor: QUOTE_COLORS[i], display: "grid", placeItems: "center", fontSize: "1.3rem", flexShrink: 0 }}>
                    👨‍👩‍👧
                  </Box>
                  <Box>
                    <Typography sx={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 800, color: NAVY, fontSize: "0.9rem" }}>{t.name}</Typography>
                    <Typography sx={{ color: "#4A4E6D", fontWeight: 600, fontSize: "0.78rem" }}>St Lord's Parent</Typography>
                  </Box>
                  <Box sx={{ ml: "auto", color: YELLOW, fontSize: "1rem" }}>⭐⭐⭐⭐⭐</Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Dots */}
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
          {testimonials.map((_, i) => (
            <Box key={i} component="button" onClick={() => setActive(i)} sx={{ width: i === active ? 28 : 10, height: 10, borderRadius: 999, border: `2px solid ${NAVY}`, backgroundColor: i === active ? CORAL : "transparent", cursor: "pointer", transition: "all 0.3s", p: 0 }} />
          ))}
        </Box>
      </Container>
    </AnimatedSection>
  );
};

export default TestimonialsSection;
